import React, { useEffect, useState } from 'react'
import { get } from '../../util/request';
import { useSelector } from 'react-redux';
import Datepicker from 'react-tailwindcss-datepicker';

const ProfileLaporanKerja = () => {
  const [state, setState] = useState({
    absensList: '',
    form: {
      employee_id: '',
      company_id: '',
    },
    date: '',
    dateForm: '',
    loading: true
  })

  const jwtToken = useSelector(state => state.auth.generateToken)
  const user = useSelector(state => state.auth.user)

  useEffect(() => {
    let isMounted = true
    if (isMounted) {

      getListAbsen()
    }
    return () => isMounted === false
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.date])

  const getListAbsen = () => {
    get(
      `public/api/v1/report-list?companyId=${user.company_id}&employeeId=${user.employee_id}&date=${state.date}`,
      {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          'Content-Type': 'application/json'
        },
      },
      success => {
        setState({
          ...state,
          absensList: success.data.Data,
          loading: false
        })

      },
      error => {
        setState(prevState => {
          return {
            ...prevState,
            loading: false
          }
        })
        console.log('error request', error)
      }
    )
  }

  const handleValueChange = (e, name) => {
    setState({
      ...state,
      [name]: e.startDate,
      dateForm: e
    })

  }
  return (
    state.loading ? "" :
      <div className='w-full h-screen grid-cols-1 bg-real-white sm:grid-cols-2'>
        <div className='w-full h-20 bg-real-white'>
          <div className='flex items-center h-full px-4'>
            <a href={process.env.PUBLIC_URL + "/profile"}>
              <img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/arrow-left.svg"} className='justify-start w-10 py-1' />
            </a>
            <p className='px-4'>Detail Laporan Kerja</p>
          </div>
        </div>
        <div className='w-full px-4 bg-real-white'>
          <div className="mt-2.5">
            <input
              type="text"
              name="phone_no"
              id="phone_no"
              placeholder='Cari Berdasarkan nama/kode/dll'
              // onChange={(e) => handleValueChange(e)}
              // value={state.form.phone_no}
              className="block w-full rounded-md border-0 px-3.5 py-4 bg-white text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
          </div>
          <div className='flex items-center w-full h-full gap-2 py-4' >
            <div className='w-1/2'>Filter </div>
            <Datepicker
              asSingle={true}
              useRange={false}
              placeholder={"Tanggal Laporan"}
              primaryColor={"blue"}
              value={state.dateForm}
              onChange={(e) => handleValueChange(e, "date")}
            />

          </div>
        </div>
        <div>

          <div className='grid h-full grid-cols-1 bg-white rounded-3xl'>
            {state.absensList?.map((item, index) => (
              <div className="p-4 mx-4 mt-4 rounded-lg bg-real-white" key={index}>
                <div className='flex'>
                  <p className='w-full text-base font-bold text-left'>{item.sprint_log?.tc_code}</p>
                  <p className='w-full text-base font-bold text-left'>{item.sprint_log?.related_page}</p>
                </div>
                <div className='p-2'>
                  <p className='w-full text-sm font-bold text-left'>Issue Detail: </p>
                  <p className='w-full text-sm text-left'>{item.sprint_log?.issue_detail}</p>
                </div>
                <div className='flex px-2 py-1'>
                  <div className='w-1/2 text-sm font-semibold text-left '>
                    <p className='font-bold'>Status</p>
                    <p style={{
                      color: item.report_status?.report_status_name === "TO DO" ? "#2200ba" :
                        item.report_status?.report_status_name === "IN PROGRESS" ? "#fff200" :
                          item.report_status?.report_status_name === "IN REVIEW" ? "#00b87a" :
                            item.report_status?.report_status_name === "DONE" ? "#1bc700" :
                              item.report_status?.report_status_name === "FEEDBACK" ? "#b00000" :
                                item.report_status?.report_status_name === "RESOURCE" ? "#7e00e6" :
                                  "#804200"
                    }}> {item.report_status?.report_status_name}</p>
                  </div>
                  <div className='w-1/2 text-sm font-semibold text-left'>
                    <p className='font-bold'>Priority</p>
                    <p style={{ color: item.report_status?.priority_name === "High" ? "#DD5353" : item.report_status?.priority_name === "Medium" ? "green" : "#FF7C32" }}>{item.sprint_log?.priority?.priority_name}</p>
                  </div>

                </div>
                <div className='flex items-start py-1'>
                  <p>Comments : {item.comment}</p>
                </div>

              </div>
            ))}

          </div>
        </div>




      </div >
  )
}

export default ProfileLaporanKerja